// App.js
import React from "react";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IoTSensing from "./pages/IoTSensing";
import Dashboard from "./pages/Dashboard";
import WildlifeThreats from "./pages/WildlifeThreats";
import DroneStreaming from "./pages/DroneStreaming";
import Insights from "./pages/Insights";
import DroneMap from "./pages/DroneMap";
import SignOut from "./pages/SignOut";
import LoginPage from "./pages/LoginPage";
import InsightsDashboard from './components/Dashboard/InsightsDashboard';


function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/*" element={<MainLayout />} />
            </Routes>
        </Router>
    );
}

const MainLayout = () => (
    <div className="flex min-h-screen font-sans bg-gray-100">
        <Sidebar />
        <main className="flex-1 p-6">
            <Header />
            <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/wildlife-threats" element={<WildlifeThreats />} />
                <Route path="/drone-streaming" element={<DroneStreaming />} />
                <Route path="/iot-sensing" element={<IoTSensing />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/drone-map" element={<DroneMap />} />
                <Route path="/sign-out" element={<SignOut />} />
            </Routes>
        </main>
    </div>
);

export default App;
